"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Comment = exports.default = Comment;
exports.CommentWithReplyField = CommentWithReplyField;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Tooltip = require("../../ui_elements/tooltip/Tooltip");

var _Avatar = _interopRequireDefault(require("../../ui_elements/avatar/Avatar"));

var _Markdown = _interopRequireDefault(require("../../base/Markdown"));

var _typography = require("../../base/typography");

var _indicators = require("../../ui_elements/indicators");

var _CommentForms = require("./CommentForms");

var _hooks = require("../../hooks");

var _commentStyle = require("./commentStyle");

var _AnnotationStoryText = _interopRequireDefault(require("./AnnotationStoryText"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function Comment(props) {
  var id = props.id,
      body = props.body,
      highlightedText = props.highlightedText,
      avatar = props.avatar,
      fullName = props.fullName,
      authorIsOwner = props.authorIsOwner,
      formattedCreatedAt = props.formattedCreatedAt,
      canBeUpdated = props.canBeUpdated,
      authorTooltip = props.authorTooltip,
      authorBadge = props.authorBadge,
      authorBadgeColor = props.authorBadgeColor,
      onResolve = props.onResolve,
      allowUnresolve = props.allowUnresolve,
      onUnresolve = props.onUnresolve,
      onEditSubmit = props.onEditSubmit,
      onEditCancel = props.onEditCancel,
      children = props.children,
      showChildren = props.showChildren,
      updatedAt = props.updatedAt,
      width = props.width,
      showReplyForm = props.showReplyForm,
      resolved = props.resolved,
      users = props.users,
      createdAt = props.createdAt,
      inStoryText = props.inStoryText;

  var _useRelativeTime = (0, _hooks.useRelativeTime)(formattedCreatedAt),
      _useRelativeTime2 = _slicedToArray(_useRelativeTime, 2),
      relativeDatetime = _useRelativeTime2[0],
      formattedDatetime = _useRelativeTime2[1];

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      editMode = _useState2[0],
      setEditMode = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      commentResolved = _useState4[0],
      setResolved = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      inputVal = _useState6[0],
      setInputVal = _useState6[1];

  (0, _react.useEffect)(function () {
    setInputVal(body);
  }, [body]);
  (0, _react.useEffect)(function () {
    setResolved(resolved);
  }, [resolved]);
  var useRelativeUpdate = updatedAt > createdAt;
  var updated = useRelativeUpdate ? updatedAt : null;

  var _useRelativeTime3 = (0, _hooks.useRelativeTime)(updated),
      _useRelativeTime4 = _slicedToArray(_useRelativeTime3, 2),
      relativeUpdatedAt = _useRelativeTime4[0],
      formattedUpdatedDatetime = _useRelativeTime4[1];

  var handleEdit = function handleEdit() {
    if (authorIsOwner) {
      setEditMode(true);
    }
  };

  var handleSubmit = function handleSubmit(data) {
    setInputVal(data.edit);
    onEditSubmit(data);
    setEditMode(false);
  };

  var handleCancel = function handleCancel() {
    onEditCancel();
    setEditMode(false);
  };

  var handleResolved = function handleResolved() {
    setResolved(true);
    onResolve();
  };

  var handleUnresolved = function handleUnresolved() {
    setResolved(false);
    onUnresolve();
  };

  return /*#__PURE__*/_react.default.createElement(_commentStyle.CommentWrapper, {
    key: "comment-".concat(id),
    width: width,
    commentResolved: commentResolved,
    showReplyForm: showReplyForm
  }, /*#__PURE__*/_react.default.createElement(_commentStyle.OpeningThreadContainer, null, /*#__PURE__*/_react.default.createElement(_commentStyle.CommentHeaderContainer, null, /*#__PURE__*/_react.default.createElement(_commentStyle.FlexPresenter, null, /*#__PURE__*/_react.default.createElement(_commentStyle.FlexWrapper, null, /*#__PURE__*/_react.default.createElement(_commentStyle.FlexContent, {
    style: {
      height: '30px'
    }
  }, /*#__PURE__*/_react.default.createElement(_commentStyle.ArticleIcon, {
    type: "comment"
  }), /*#__PURE__*/_react.default.createElement(_typography.H6, null, "Comment")), !editMode && /*#__PURE__*/_react.default.createElement(_commentStyle.FlexContent, null, commentResolved ? /*#__PURE__*/_react.default.createElement(_commentStyle.FlexWrapper, null, /*#__PURE__*/_react.default.createElement(_indicators.Indicator, {
    text: "Resolved"
  }, "Resolved"), allowUnresolve && /*#__PURE__*/_react.default.createElement(_commentStyle.IndicatorButton, {
    onClick: function onClick() {
      return handleUnresolved();
    },
    text: "Re-Open"
  }, "Re-Open")) : /*#__PURE__*/_react.default.createElement(_commentStyle.ResolveButton, {
    size: "small",
    onClick: handleResolved
  }, "Resolve"))))), /*#__PURE__*/_react.default.createElement(_commentStyle.CommentBodyContainer, null, /*#__PURE__*/_react.default.createElement(_commentStyle.AvatarPresenter, null, /*#__PURE__*/_react.default.createElement(_commentStyle.FlexStartWrapper, null, /*#__PURE__*/_react.default.createElement(_commentStyle.FlexStartContent, null, /*#__PURE__*/_react.default.createElement(_Avatar.default, {
    src: avatar,
    alt: fullName,
    tooltip: {
      text: authorTooltip,
      left: '15px'
    },
    badgeText: authorBadge,
    badgeColor: authorBadgeColor,
    size: "large"
  }), /*#__PURE__*/_react.default.createElement(_commentStyle.AuthorName, null, fullName)), /*#__PURE__*/_react.default.createElement(_typography.Subtext, {
    style: {
      marginLeft: 'auto',
      fontWeight: "400"
    }
  }, /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
    position: "start",
    content: formattedDatetime
  }, /*#__PURE__*/_react.default.createElement("span", null, relativeDatetime)), updatedAt && updatedAt > createdAt && /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
    position: "start",
    content: formattedUpdatedDatetime
  }, /*#__PURE__*/_react.default.createElement("span", null, " \u2022 Updated ", relativeUpdatedAt, " "))), /*#__PURE__*/_react.default.createElement(_commentStyle.FlexContent, null, authorIsOwner && !commentResolved && canBeUpdated && /*#__PURE__*/_react.default.createElement(_commentStyle.EditIcon, {
    type: "pencil",
    "aria-label": "edit",
    onClick: handleEdit
  })))), highlightedText && !commentResolved && /*#__PURE__*/_react.default.createElement(_AnnotationStoryText.default, {
    highlightedText: highlightedText,
    inStoryText: inStoryText
  })), editMode && /*#__PURE__*/_react.default.createElement(_commentStyle.BodyContainer, null, /*#__PURE__*/_react.default.createElement(_commentStyle.CommentFormContainer, null, /*#__PURE__*/_react.default.createElement(_CommentForms.EditForm, {
    onSubmit: handleSubmit,
    onCancel: handleCancel,
    body: inputVal,
    users: users
  }))), !editMode && /*#__PURE__*/_react.default.createElement(_commentStyle.BodyContainer, null, /*#__PURE__*/_react.default.createElement(_Markdown.default, null, inputVal))), showChildren && children);
}

var userShape = {
  id: _propTypes.default.number.isRequired,
  display: _propTypes.default.string.isRequired,
  avatar: _propTypes.default.string.isRequired
};
Comment.defaultProps = {
  body: '',
  highlightedText: '',
  authorIsOwner: true,
  canBeUpdated: true,
  authorTooltip: '',
  authorBadge: '',
  authorBadgeColor: '',
  children: null,
  showChildren: true,
  updatedAt: null,
  createdAt: null,
  width: null,
  showReplyForm: undefined,
  allowUnresolve: false,
  resolved: 0,
  onEditSubmit: function onEditSubmit() {},
  onEditCancel: function onEditCancel() {},
  onUnresolve: function onUnresolve() {},
  users: [],
  inStoryText: false
};
Comment.propTypes = {
  id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
  body: _propTypes.default.string,
  highlightedText: _propTypes.default.string,
  avatar: _propTypes.default.string.isRequired,
  fullName: _propTypes.default.string.isRequired,
  authorIsOwner: _propTypes.default.bool,
  formattedCreatedAt: _propTypes.default.string.isRequired,
  authorTooltip: _propTypes.default.string,
  authorBadge: _propTypes.default.string,
  authorBadgeColor: _propTypes.default.string,
  onResolve: _propTypes.default.func.isRequired,
  allowUnresolve: _propTypes.default.bool,
  onUnresolve: _propTypes.default.func,
  onEditSubmit: _propTypes.default.func,
  onEditCancel: _propTypes.default.func,
  children: _propTypes.default.element,
  showChildren: _propTypes.default.bool,
  updatedAt: _propTypes.default.string,
  createdAt: _propTypes.default.string,
  width: _propTypes.default.string,
  showReplyForm: _propTypes.default.bool,
  canBeUpdated: _propTypes.default.bool,
  resolved: _propTypes.default.number,
  users: _propTypes.default.arrayOf(_propTypes.default.shape(userShape)),
  inStoryText: _propTypes.default.bool
};

function CommentWithReplyField(props) {
  var onReplySubmit = props.onReplySubmit,
      onReplyCancel = props.onReplyCancel,
      id = props.id,
      showReplyForm = props.showReplyForm,
      handleClick = props.handleClick,
      borderBottom = props.borderBottom,
      borderSides = props.borderSides,
      border = props.border,
      editMode = props.editMode,
      width = props.width,
      users = props.users,
      highlightedText = props.highlightedText,
      borderLeft = props.borderLeft;
  return /*#__PURE__*/_react.default.createElement(_commentStyle.CommentListContainer, {
    onClick: handleClick,
    width: width,
    border: border,
    showReplyForm: showReplyForm,
    highlightedText: highlightedText,
    borderLeft: borderLeft
  }, /*#__PURE__*/_react.default.createElement(Comment, _extends({}, props, {
    key: id
  })), showReplyForm && !editMode && /*#__PURE__*/_react.default.createElement(_CommentForms.ReplyForm, {
    onSubmit: onReplySubmit,
    onCancel: onReplyCancel,
    borderBottom: borderBottom,
    borderSides: borderSides,
    users: users
  }));
}

CommentWithReplyField.defaultProps = {
  onEditCancel: function onEditCancel() {},
  showReplyForm: true,
  handleClick: null,
  borderBottom: true,
  borderSides: true,
  borderLeft: false,
  border: false,
  editMode: false,
  width: null,
  users: [],
  highlightedText: '',
  inStoryText: false
};
CommentWithReplyField.propTypes = {
  id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
  onReplySubmit: _propTypes.default.func.isRequired,
  onEditSubmit: _propTypes.default.func.isRequired,
  onReplyCancel: _propTypes.default.func.isRequired,
  onEditCancel: _propTypes.default.func,
  handleClick: _propTypes.default.func,
  showReplyForm: _propTypes.default.bool,
  borderBottom: _propTypes.default.bool,
  borderSides: _propTypes.default.bool,
  borderLeft: _propTypes.default.bool,
  border: _propTypes.default.bool,
  editMode: _propTypes.default.bool,
  width: _propTypes.default.string,
  users: _propTypes.default.arrayOf(_propTypes.default.shape(userShape)),
  highlightedText: _propTypes.default.string,
  inStoryText: _propTypes.default.bool
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/comments/Comment/index.js
// module id = 813
// module chunks = 0 15 16 17 18